import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c7fez4m2dq: FaireBrandEntity = {
  token: "b_c7fez4m2dq",
  type: "brand",
  name: "Special Supplies",
  avatarUrl:
    "https://cdn.faire.com/fastly/cdb942a7d67a6962ad28faa4b97fc0f2837fe7fc39a46529fcc4bc0b4c9e68ff.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bf2a33e07718587479b2e5c064efc19c5380b3260f09e4a963599dfb8eaa8517.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cdb942a7d67a6962ad28faa4b97fc0f2837fe7fc39a46529fcc4bc0b4c9e68ff.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bf2a33e07718587479b2e5c064efc19c5380b3260f09e4a963599dfb8eaa8517.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "Special Supplies was founded with a goal to address the difficulty parents and educators encounter when attempting to find reliable, safe and effective tools for special needs children. We discovered that by doing our due diligence to ensure that our products were effective and safe, we were taking a load off the shoulders of those most invested in the well-being of special needs children. From the beginning, it’s been our goal to ease this process and create a hassle-free and seamless customer experience. All of our products are selected by a team of parents and experienced therapists which helps us ensure we provide the very best in Oral Motor, Fine Motor, Gross Motor, Daily Living, School, and Sensory products. Our passion is not only to raise awareness about the issues facing those with Autistic and sensory integration needs, but to offer a therapeutic solution at an affordable price.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:30.600Z",
    importedBy: "entity-db-cli",
  },
};
